import React, { createContext, useEffect, useState } from "react";

export const CacheContext = createContext<any>({
  cache:null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCache: (value: any) => {},
});

// Parses the persisted cache, discarding it if it is no longer valid JSON
// (e.g. corrupted or truncated by a previous session/version).
const readPersistedCache = (cacheData: string): Array<any> | null => {
  try {
    return JSON.parse(cacheData);
  } catch {
    localStorage.setItem("cacheData", "");
    return null;
  }
};

export const CacheContextProvider = (props: any) => {
  useEffect(() => {
    const cacheData = localStorage.getItem("cacheData");
    const token = localStorage.getItem("access_token");
    const parsedCache = cacheData && cacheData !== "" ? readPersistedCache(cacheData) : null;
    if (parsedCache) {
      setCache(parsedCache);
    } else if (token && token !== "") {
      window.location.href = "/";
      localStorage.setItem("access_token", "");
    }
  }, [localStorage]);

  const setCache = (cache: Array<any>) => {
    localStorage.setItem("cacheData", JSON.stringify(cache));
    setState({ ...state, cache: cache });
    
  };
  const initState = {
    cache: new Array<any>(),
    setCache: setCache,
  };
  const [state, setState] = useState(initState);
  return (
    <CacheContext.Provider value={state}>
      {props.children}
    </CacheContext.Provider>
  );
};
